











import Vue from 'vue';
import VueCompositionAPI, {computed, defineComponent} from '@vue/composition-api';
import ImageStack from './image-stack.vue';
Vue.use(VueCompositionAPI);

export interface POIDetails {
  id: string;
  img: string;
  name: string;
}

export interface POIDetailsProps {
  isParent: boolean;
  pois: POIDetails[];
}

const POIRelationsComponent = defineComponent({
  components: {
    ImageStack,
  },
  props: {
    isParent: {
      type: Boolean,
      default: false,
    },
    pois: {
      type: Array,
      default: () => [],
    },
  },
  setup(props: POIDetailsProps, {emit}) {
    const pois = computed(() => {
      return props.pois || [];
    });

    const images = computed(() => {
      return pois.value.map((poi) => poi.img);
    });

    const names = computed(() => {
      return pois.value.map((poi) => poi.name).join(', ');
    });

    return {
      images,
      names,
    };
  },
});

export default POIRelationsComponent;
